import { AxiosError } from 'axios';

import { getAuthServiceUrl } from '../../../utils/url';
import { axiosRetryDefault, authAxiosInstance as network } from '../../axios';
import { Endpoints } from '../../enums';
import { GetAuth0SessionResponse } from '../../types';
import { getRetailUnitAndLanguage } from '../../utils/getRetailUnitAndLanguage';
import { checkSsoInIframe, shouldTryToSilentlyLogin } from './getVerifiedAuthStatus';

export const getAuth0Session = async (signal?: AbortSignal) => {
  const { retailUnit, language: lang } = getRetailUnitAndLanguage();

  if (shouldTryToSilentlyLogin()) {
    try {
      await checkSsoInIframe({
        authServiceBaseUrl: getAuthServiceUrl(),
        retailUnit,
        lang,
      });
    } catch {
      // We couldn't silently log in, but we might still be logged in so let's still call auth
    }
  }

  const response = await network
    .get<GetAuth0SessionResponse>(Endpoints.GetAuth0Session, {
      signal,
      'axios-retry': {
        retryCondition: (error: AxiosError<any>) => {
          if (error.response?.status === 400) return true;
          return axiosRetryDefault(error);
        },
      },
    })
    .catch((e) => {
      console.error('error in getAuth0Session', e);
      throw e;
    });

  return response.data;
};
